import { useState } from 'react'

export default function LoginForm({ onLogin, onToggleRegister }) {
  const [pin, setPin] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [touched, setTouched] = useState(false)
  const [_error, setError] = useState('')

  const valid = pin.trim().length > 0

  const submit = async (e) => {
    e.preventDefault()
    setTouched(true)
    setError('')
    setSubmitting(true)
    setTimeout(() => {
      onLogin()
      setSubmitting(false)
    }, 300)
  }

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          <div className="auth-title">Sign in</div>
        </div>

        <form onSubmit={submit} noValidate className="auth-form">
          <div className="auth-field">
            <label htmlFor="pin" className="auth-label">Passcode</label>
            <input
              id="pin"
              inputMode="numeric"
              pattern="[0-9]*"
              autoComplete="one-time-code"
              value={pin}
              onChange={(e) => setPin(e.target.value)}
              placeholder="Enter passcode"
              aria-invalid={touched && !valid}
              className={`auth-input ${touched && !valid ? 'auth-input-error' : ''}`}
              autoFocus
            />
            {touched && !valid && (
              <div className="auth-error">Enter a valid passcode</div>
            )}
          </div>

          <div className="auth-footer">
            <div className="auth-switch">
              No account? <a href="#" onClick={(e) => { e.preventDefault(); onToggleRegister(); }} className="auth-link">Create one!</a>
            </div>

            <div className="auth-actions">
              <a href="#" className="auth-link">Sign-in options</a>
              <button
                type="submit"
                disabled={submitting || !valid}
                className="auth-btn auth-btn-primary"
              >
                {submitting ? 'Loading…' : 'Next'}
              </button>
            </div>
          </div>
        </form>

        <div className="auth-note">Authorized access only</div>
      </div>
    </div>
  )
}
